<div class="container">

  <h4 class="form-page-name">
    Contractor Directory
  </h4>

  @if ((currentContact?.isContractor && (currentContact?.femaTrained || currentContact?.essFemaTrained|| currentContact?.emrFemaTrained))) {
    <div
      class="retrofit-form-text">
      <div class="retrofit-form-text">
        <div [innerHTML]="textContractorDirectoryFemaComplete"></div>
      </div>
      <h6>Your current listing</h6>
      <div style="border: solid; border-width: 1px; border-color: #8f8f8f; background:white;">
        <div fxLayout="row" fxLayout.lt-md="column wrap">
          <div fxFlex='20%'>
            <img [src]="businessLogo" alt="{{currentContact.businessName + ' logo'}}"
              (error)="getContractorImageError($event)"
              style="max-width: 125px; max-height: 75px; margin: 9px;">
            </div>
            <div fxFlex='30%'>
              <div style="margin-top: 12px;" ngStyle.lt-md="{'margin-left': '9px'}">
                <div
                  matTooltip="{{currentContact.businessName}}"
                  class="business-name"
                  >
                  {{ currentContact.businessName }}
                </div>
                <div style="font-size: 12px;">
                  {{ currentContact.address2_Line1 }}, {{ !this.util.isEmpty(currentContact.address2_Line2) ? currentContact.address2_Line2 + ',' : '' }} {{ currentContact.address2_City }}, {{ currentContact.address2_StateOrProvince }}
                  {{ currentContact.address2_PostalCode }}
                </div>
                <div style="font-size: 12px;">
                  (License #:
                  @if (
                    currentContact.contractorLicenseNumber &&
                    currentContact.contractorLicenseNumber.length > 0) {
                    <span
                      >
                      {{ currentContact.contractorLicenseNumber }})
                    </span>
                  } @else {
                    <span>Unavailable)</span>
                  }
                </div>
                @if (currentContact.advertiseYourself && currentContact.advertiseYourself.length > 1) {
                  <div style="font-size: 12px;">
                    About Us: {{this.showMore ? currentContact.advertiseYourself : (currentContact.advertiseYourself | truncate) }}
                    @if (currentContact.advertiseYourself.length > 30) {
                      <a href
                      (click)="onToggleMoreContractor($event)">{{this.showMore ? 'less' : 'more' }}</a>
                    }
                  </div>
                }
                @if (currentContact.hasReview) {
                  <div style="font-size: 12px;">
                    <a href
                    (click)="onShowReviews($event)">Homeowner Reviews</a>
                  </div>
                }
              </div>
            </div>
            <div fxFlex='30%'>
              <div style="margin-top: 12px;" ngStyle.lt-md="{'margin-left': '9px'}">
                <div style="font-size: 12px;">
                  Email: {{currentContact.emailAddress1}}
                </div>
                <div style="font-size: 12px;">
                  Phone:
                  @if (currentContact.address2_Telephone1 && currentContact.address2_Telephone1.length > 0) {
                    <span
                      >
                      {{currentContact.address2_Telephone1}}
                    </span>
                  } @else {
                    <span>Unavailable</span>
                  }
                </div>
                <div style="font-size: 12px;">
                  Web:
                  @if (currentContact.webSiteUrl && currentContact.webSiteUrl.length > 0) {
                    <span>
                      <a target="_blank" rel="noopener" href="{{formatLink(currentContact.webSiteUrl)}}">
                      {{formatLink(currentContact.webSiteUrl)}}</a>
                    </span>
                  } @else {
                    <span>Unavailable</span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <form [formGroup]="formIncludeInDirectory">
          @if (currentContact?.isContractor && currentContact?.femaTrained) {
            <div class="mt-3 ml-3" role="group">
              <mat-checkbox
                id="withdrawFromEbbDirectory"
                formControlName="withdrawFromEbbDirectory"
                (change)="onChangeIncludeInDirectory($event,'EBB')">
                No, please exclude me from the Earthquake Brace + Bolt Contractor Directory
              </mat-checkbox>
            </div>
          }
          @if (currentContact?.isContractor && currentContact?.essFemaTrained) {
            <div class="mt-3 ml-3" role="group">
              <mat-checkbox
                id="withdrawFromEssDirectory"
                formControlName="withdrawFromEssDirectory"
                (change)="onChangeIncludeInDirectory($event,'ESS')">
                No, please exclude me from the Earthquake Soft Story Contractor Directory
              </mat-checkbox>
            </div>
          }
          @if (currentContact?.isContractor && currentContact?.emrFemaTrained) {
            <div class="mt-3 ml-3" role="group">
              <mat-checkbox
                id="withdrawFromEmrDirectory"
                formControlName="withdrawFromEmrDirectory"
                (change)="onChangeIncludeInDirectory($event,'EMR')">
                No, please exclude me from the Earthquake Multi-Unit Contractor Directory
              </mat-checkbox>
            </div>
          }
        </form>
        <div style="margin-top: 24px;">
          <button mat-stroked-button color="primary"
            (click)="navigateToAccount()">
            EDIT MY CONTRACTOR DIRECTORY LISTING
          </button>
        </div>
        <div style="margin-top: 24px;">
          <button mat-stroked-button color="primary"
            (click)="showContractorDirectory('EBB|FEMA|ESS')">
            VIEW CONTRACTOR DIRECTORY
          </button>
        </div>
        <h6 style="margin-top: 36px;">
          Current list of ZIP Codes you serve
        </h6>
        <mat-divider></mat-divider>
        @if (currentzipcodesgroupbycounty?.length > 0) {
          <div class="mat-elevation-z8"  >
            <table mat-table [dataSource]="currentzipcodesgroupbycounty" class="mat-table">
              <!-- County Column -->
              <ng-container matColumnDef="county">
           <th scope="col" mat-header-cell *matHeaderCellDef style=" width: 250px;white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;"> County </th>
                <td mat-cell *matCellDef="let element"> {{element.county}} </td>
              </ng-container>
              <!-- Zip Codes Column -->
              <ng-container matColumnDef="zipCodes">
           <th scope="col" mat-header-cell *matHeaderCellDef  style=" width: 1100px; white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;" > Zip Codes </th>
                <td mat-cell *matCellDef="let element"> {{element.zipCodes}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        } @else {
          <span>No ZIP codes are currently specified.</span>
        }
        <!-- <div *ngIf="currentContractorServiceZip?.length > 0 else noContractorServiceZip">
        <span *ngFor="let zip of currentContractorServiceZip">
          {{zip.zipCode}}
        </span>
      </div> -->
      <p style="margin-top: 15px;">
        You can update ZIP Codes you service using the buttons below.
      </p>
      <!-- <button mat-stroked-button color="primary" disabled="isLoading"
      (click)="addServiceZipCode()">
      ADD ZIP CODE
    </button> -->
    <!-- <button mat-stroked-button color="primary" [disabled]="isLoading" (click)="addServiceZipCode()">
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
    <span *ngIf="!isLoading">ADD ZIP CODE</span>
    <span *ngIf="isLoading">Saving...</span>
  </button> -->
  <button mat-stroked-button color="primary" [disabled]="isLoading" (click)="addServiceZipCode()">
    ADD SERVICE ZIP CODES
  </button>
</div>
} @else {
  <div class="retrofit-form-text">
    <div [innerHTML]="textContractorDirectoryFemaIncomplete"></div>
  </div>
  <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
    <div fxFlex='25%'>
      <a mat-stroked-button color="primary"
        (click)="redirectToEBBTraining()">
        GO TO BRACE BOLT COURSE
      </a>
    </div>
    <div fxFlex='25%' class="ess-content">
      <a mat-stroked-button color="primary"
        (click)="redirectToESSTraining()">
        GO TO SOFT STORY COURSE
      </a>
    </div>
    <div fxFlex='25%' class="emr-content">
      <a mat-stroked-button color="primary"
        (click)="redirectToEMRTraining()">
        GO TO MULTI-UNIT COURSE
      </a></div>
    </div>
  }
  @if (currentContractorServiceZip?.length > 0) {
    <div style="margin-top: 24px;">
      <button mat-stroked-button color="primary" (click)="deleteServiceZipCode()">
        REMOVE SERVICE ZIP CODES
      </button>
    </div>
  }

  <div style="min-height: 50px;"></div>

</div>


